import React from "react";
import Page from "components/Page";
import { Props } from "./CatalogueGroupCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const CatalogueGroupCustomTypes = lazyWithRetry(() =>
  import("./CatalogueGroupCustomTypes")
);

export default (props: Props) => (
  <Page>
    <CatalogueGroupCustomTypes {...props} />
  </Page>
);
